<template>
  <div id="clockdiv">
    <span
      class="tag badge badge-danger count-header s-text msu-semibold"
      :class="size === 'lg' ? 'count-header' : ''"
    >
      <span v-if="isExpired">
        <i class="zmdi zmdi-time zmdi-hc-fw text-white"></i>
        {{ $t("expired") || "Expired" }}
      </span>
      <span v-else-if="cdays >= 1">
        <i class="zmdi zmdi-hourglass-alt zmdi-hc-fw text-white"></i
        >{{ $t("cdays-days", [cdays]) }}
      </span>
      <span v-else>
        <i class="zmdi zmdi-hourglass-alt zmdi-hc-fw text-white"></i>
        <span class="hours">
          {{ chours }}
        </span>
        :
        <span class="minutes">
          {{ cminutes }}
        </span>
        :
        <span class="seconds">
          {{ cseconds }}
        </span>
      </span>
    </span>
  </div>
</template>
<script setup>
const props = defineProps({
  size: String,
  expiryTime: {
    type: String,
    default: () => null,
  },
});

const cdays = ref();
const chours = ref();
const cminutes = ref();
const cseconds = ref();
const deadline = ref(null);
const onlyShowDay = ref(false);

// 計算屬性：判斷是否已過期
const isExpired = computed(() => {
  if (!props.expiryTime) return false;
  const total =
    Date.parse($dayjs.unix(props.expiryTime).format()) - Date.parse(new Date());
  return total <= 0;
});

const getTimeRemaining = (endtime) => {
  const total = Date.parse(endtime) - Date.parse(new Date());

  // 如果時間已經過期，返回全零
  if (total <= 0) {
    return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  // console.log(days, hours, minutes, seconds);
  return { total, days, hours, minutes, seconds };
};

const timeinterval = ref(null);
const initializeClock = (id, endtime) => {
  // const t = getTimeRemaining(deadline.value);
  const t = getTimeRemaining($dayjs.unix(props.expiryTime).format());
  // console.log(t);

  // 確保所有值都是非負數
  cdays.value = Math.max(0, t.days);
  chours.value = ("0" + Math.max(0, t.hours)).slice(-2);
  cminutes.value = ("0" + Math.max(0, t.minutes)).slice(-2);
  cseconds.value = ("0" + Math.max(0, t.seconds)).slice(-2);

  // 如果時間已過期，停止計時器
  if (t.total <= 0) {
    if (timeinterval.value !== null) {
      clearInterval(timeinterval.value);
      timeinterval.value = null;
    }
    // 確保顯示為 00:00:00
    cdays.value = 0;
    chours.value = "00";
    cminutes.value = "00";
    cseconds.value = "00";
  }
  //
};
watch(
  () => props.expiryTime,
  (nval, oval) => {
    if (nval !== oval) {
      console.log("update expiryTime");
      initializeClock("clockdiv", $dayjs.unix(nval).format());
    }
  }
);

const $dayjs = inject("$dayjs");
onMounted(() => {
  // set time

  timeinterval.value = setInterval(initializeClock, 1000);
  // console.log(props.expiryTime);
  initializeClock("clockdiv", $dayjs.unix(props.expiryTime).format());
});

onUnmounted(() => {
  // 清理計時器
  if (timeinterval.value !== null) {
    clearInterval(timeinterval.value);
    timeinterval.value = null;
  }
});
</script>
<style lang="scss"></style>
